var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
import { BASE_ENDPOINT, DOMAIN, ENDPOINTS, HEADERS, PORT, TIMEOUT, } from './defaults';
var defaultInitializer = {
    domain: undefined,
    port: undefined,
    isSecured: undefined,
    timeout: undefined,
    headers: undefined,
    contextPath: '',
    apiVersion: 1,
};
var ExactaAPI = (function () {
    function ExactaAPI(_a) {
        var _this = this;
        var _b = _a === void 0 ? defaultInitializer : _a, domain = _b.domain, port = _b.port, isSecured = _b.isSecured, timeout = _b.timeout, headers = _b.headers, _c = _b.contextPath, contextPath = _c === void 0 ? '' : _c, apiVersion = _b.apiVersion;
        this.setAuthorizationHeader = function (token) {
            console.log('ex-mat-react', 'token', token);
            _this.axiosInstance.defaults.headers.common['Set-Authorization'] = token;
            _this.token = token;
        };
        this.login = function (login, password, app) {
            if (login === void 0) { login = ''; }
            if (password === void 0) { password = ''; }
            var body = {
                login: login,
                password: password,
                app: app,
            };
            return _this.axiosInstance
                .post(ENDPOINTS.LOGIN, __assign({}, body))
                .then(function (response) { return ({ response: response }); })
                .catch(function (error) { return ({ error: error }); });
        };
        this.logout = function () {
            return _this.axiosInstance
                .post(ENDPOINTS.LOGOUT)
                .then(function (response) {
                _this.token = undefined;
                _this.axiosInstance.defaults.headers.common['Set-Authorization'] = '';
                return { response: response };
            })
                .catch(function (error) { return ({ error: error }); });
        };
        this.get = function (request, options) {
            if (options === void 0) { options = {}; }
            var body = {
                request: request,
            };
            return _this.axiosInstance
                .post(ENDPOINTS.GET, __assign({}, body), options)
                .then(function (response) { return ({ response: response }); })
                .catch(function (error) { return ({ error: error }); });
        };
        this.execute = function (requests, isFormData) {
            if (isFormData === void 0) { isFormData = false; }
            var body = isFormData ? requests : { requests: requests };
            var config = isFormData
                ? { headers: { 'Content-Type': 'multipart/form-data' } }
                : {};
            return _this.axiosInstance
                .post(ENDPOINTS.EXECUTE, body, config)
                .then(function (response) { return ({ response: response }); })
                .catch(function (error) { return ({ error: error }); });
        };
        this.download = function (value, filename) {
            var _a;
            if (value === void 0) { value = ''; }
            if (filename === void 0) { filename = ''; }
            var body = {
                value: value,
                filename: filename,
            };
            return _this.axiosInstance
                .get(ENDPOINTS.DOWNLOAD, {
                params: body,
                responseType: 'blob',
                headers: (_a = {},
                    _a['Content-Type'] = 'application/json',
                    _a['cache-control'] = 'no-cache',
                    _a),
                timeout: 0,
            })
                .then(function (response) { return ({ response: response }); })
                .catch(function (error) { return ({ error: error }); });
        };
        this.readJsonFile = function (value, filename) {
            var _a;
            if (value === void 0) { value = ''; }
            if (filename === void 0) { filename = ''; }
            var body = {
                value: value,
                filename: filename,
            };
            return _this.axiosInstance
                .get(ENDPOINTS.DOWNLOAD, {
                params: body,
                headers: (_a = {},
                    _a['Content-Type'] = 'application/json',
                    _a['cache-control'] = 'no-cache',
                    _a),
                timeout: 0,
            })
                .then(function (response) { return ({ response: response }); })
                .catch(function (error) { return ({ error: error }); });
        };
        if (!domain && !port) {
            this.baseURL = BASE_ENDPOINT;
        }
        else {
            this.baseURL = (isSecured ? 'https' : 'http') + "://" + (domain || DOMAIN) + (port != undefined ? (port ? ':' + port : '') : ':' + PORT) + contextPath + BASE_ENDPOINT;
        }
        this.axiosInstance = axios.create({
            baseURL: this.baseURL,
            timeout: timeout || TIMEOUT,
            headers: __assign(__assign({}, HEADERS), (headers || {})),
        });
        this.apiVersion = apiVersion;
        ExactaAPI.instance = this;
    }
    ExactaAPI.getInstance = function () {
        return ExactaAPI.instance;
    };
    ExactaAPI.prototype.getApiVersion = function () {
        return this.apiVersion;
    };
    return ExactaAPI;
}());
export { ExactaAPI };
//# sourceMappingURL=exactaapi.js.map